import React, { Component } from 'react';
import { cmsGetServiceSyncJobPromise, cmsGetServiceSyncJob } from '../../CallMSAPI.js';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm';
import { formatUtcToLocal } from '../../utils/dateFormatter.js';
import DATE_FORMATS from '../../constants/dateFormats.js';
import { getGrafanaSyncJobUrl, isSystemOwner } from '../../CallMSUIHelpers.js'

class SyncJobOutput extends Component { 
    constructor(props) {
        super(props);
        this.state = {
            fullData: null,
            nextGen: true
        }
    }

   componentWillMount() {
        var self = this;
        if(self.props.jobId.indexOf('-') > -1) {
            cmsGetServiceSyncJobPromise(
                self.props.account.Id,
                self.props.jobId
            ).then((data) => {
                self.setState({
                    fullData: data.data
                })
            }).catch((err) => {
                toast.error(`Unable to load full job data: ${err}`);
            })
        } else {
            cmsGetServiceSyncJob(
                self.props.account.Id,
                self.props.jobId,
                function (data) {
                    self.setState({
                        fullData: data,
                        nextGen: false
                    });
                }, function (err) {
                    toast.error(`Unable to load full job data: ${err}`);
                }
            );
        }
}

    justCopiedAction() {
        toast.success("Job output copied to clipboard");
    }

    render() {
        var self = this;
        if (!this.state.fullData) {
            return <pre>Loading...</pre>;
        } else {
            var exceptionOutput = null;
            if (self.props.hasRole('ViewExceptions') && this.state.fullData.ExceptionOutput) {
                exceptionOutput = (
                    <>
                        <div className="py-1 row system-owner-action">
                            <div className="col-md-12 text-right">
                                <i className="fa-solid fa-user-secret" title="System Owner Only" style={{ float: 'left', padding: '8px' }}></i>
                                <CopyToClipboard text={this.state.fullData.ExceptionOutput} onCopy={self.justCopiedAction}>
                                    <button className="btn btn-link btn-xs">
                                        <span>Copy Exception Job Output</span> <i className="fa-solid fa-copy"></i>
                                    </button>
                                </CopyToClipboard>
                            </div>
                        </div>

                        <pre className="code-output-limit">
                            {this.state.fullData.ExceptionOutput}
                        </pre>
                    </>
                );
            }

            var debugOutput = null;
            if (this.state.fullData.CaptureDebug && this.state.fullData.DebugOutput) {
                debugOutput = (
                    <>
                        <div className="py-1 row">
                            <div className="col-md-12 text-right">
                                <CopyToClipboard text={this.state.fullData.DebugOutput} onCopy={self.justCopiedAction}>
                                    <button className="btn btn-link btn-xs">
                                        <span>Copy Debug Job Output</span> <i className="fa-solid fa-copy"></i>
                                    </button>
                                </CopyToClipboard>
                            </div>
                        </div>

                        <pre className="code-output-limit">
                            {this.state.fullData.DebugOutput}
                        </pre>
                    </>
                );
            }

            var advice = null;
            if (this.state.fullData.Advice && this.state.fullData.Advice) {
                advice = (
                    <>
                        <p><strong>Advice: </strong></p>
                        <ReactMarkdown className="sync-markdown-wrapper" remarkPlugins={[[remarkGfm, { singleTilde: false }]]}>
                            {this.state.fullData.Advice}
                        </ReactMarkdown>
                    </>
                );
                if(this.state.nextGen){
                    let uniqueAdvice = [...new Set(this.state.fullData.Advice)];
                    advice = (
                        <>
                            <p><strong>Advice: </strong></p>
                            {uniqueAdvice.map((ad, i) => {
                                return (
                                    <p key={`advice-${i}`}>
                                        <ReactMarkdown className="sync-markdown-wrapper" remarkPlugins={[[remarkGfm, { singleTilde: false }]]}>
                                            {ad}
                                        </ReactMarkdown>
                                    </p>
                                )
                            })}
                        </>
                    );
                }
            }

            let output = this.state.fullData.Output; // Value displayed in output
            let copyText = output; // Value copied to clipboard when user clicks copy

            if(this.state.nextGen && output) {
                output = [];
                let outputText = [];

                if(this.state.fullData.Output.Sections) {
                    this.state.fullData.Output.Sections.map((line, i) => {
                    
                        output.push(
                            <span key={`outputsection-${i}`}> == {line.Name} == </span>
                        )
                        output.push(<br />)
                        outputText.push(`== ${line.Name} ==`);

                        line.Output.map((oLine, j) => {
                            let formattedLocalDate = formatUtcToLocal(oLine.TimeStamp, DATE_FORMATS.TIME);
                            output.push(
                                <span key={`outputsection-${i}-line-${j}`}>{`<${formattedLocalDate.parsedSuccessfully ? formattedLocalDate.formattedLocal : formattedLocalDate.utcDateString}>`} {oLine.Output}</span>
                            )
                            output.push(<br />)
                            outputText.push(`<${formattedLocalDate.parsedSuccessfully ? formattedLocalDate.formattedLocal : formattedLocalDate.utcDateString}> ${oLine.Output}`);
                        })
                    })
                    copyText = outputText.join('\r\n');
                }
            }

            let grafanaLink = null;
            if (this.state.nextGen && isSystemOwner(this.props.baseAccountInfo.Roles)) {
                grafanaLink = getGrafanaSyncJobUrl(this.state.fullData.Id, this.state.fullData.CreatedOn);
            }

            return (
                <>
                    <div className="py-1 row">
                        <div className="col-md-6">
                            <p><strong>Sync Job Id: </strong>{this.state.fullData.Id}</p>
                        </div>
                        <div className="col-md-6 text-right">
                            {
                                grafanaLink != null && 
                                <button className="btn btn-link btn-xs system-owner-container">
                                    <a href={grafanaLink} target="_blank" rel="noreferrer">View in Grafana</a> <i className="fa-solid fa-link"></i>
                                </button>
                            }
                            <CopyToClipboard text={copyText} onCopy={self.justCopiedAction}>
                                <button className="btn btn-link btn-xs">
                                    <span>Copy Job Output</span> <i className="fa-solid fa-copy"></i>
                                </button>
                            </CopyToClipboard>
                        </div>
                        {
                            self.props.extendedInfo &&
                            <>
                                <div className="col-md-12">
                                    <p><strong>Date: </strong>{formatUtcToLocal(this.state.fullData.CreatedOn).formattedLocal}</p>
                                </div>
                                {
                                    this.state.fullData.Type &&
                                    <div className="col-md-12">
                                        <p><strong>Sync Type: </strong>{this.state.fullData.Type}</p>
                                    </div>
                                }
                                {
                                    this.state.fullData.Status &&
                                    <div className="col-md-12">
                                        <p><strong>Sync Status: </strong>{this.state.fullData.Status}</p>
                                    </div>
                                }
                            </>
                        }
                    </div>
                    <div className="py-1 row">
                        <div className="col-md-12">
                            {advice}
                        </div>
                    </div>

                    <hr />
                    <p><strong>Output:</strong></p>
                    <pre className="code-output-limit">
                        {output}
                    </pre>

                    {debugOutput}

                    {exceptionOutput}
                </>
            );
        }
    }
}

const mapStateToProps = state => {
    const account = state.account;
    return {
        account: account.account,
        baseAccountInfo: account.baseAccountInfo,
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        hasRole: (uiPart = '') => dispatch(actions.hasRole(uiPart))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SyncJobOutput);
